import { isHandPickedOfficeProduct } from "common/utils/officeProducts";

type ProductSheet = { productId: string; product?: { referenceName?: string | null } | null };
type Option = { value: string; checked?: boolean };

/** Valeur de la case « Cocher toutes les SCPI » des fiches cabinet. */
export const ALL_OFFICE_PRODUCTS = "all";

/** Produits que « Cocher toutes les SCPI » laisse de côté : ils s'attribuent cabinet par cabinet (`isHandPickedOfficeProduct`). */
export function getHandPickedProductIds(productSheets: ProductSheet[]): Set<string> {
	return new Set(productSheets.filter((productSheet) => isHandPickedOfficeProduct(productSheet.product?.referenceName)).map((productSheet) => productSheet.productId));
}

/** « Cocher toutes les SCPI » est-elle cochée ? Les produits attribués cabinet par cabinet ne comptent pas. */
export function areAllOfficeProductsChecked(options: Option[], handPickedProductIds: Set<string>): boolean {
	const selectable = options.filter((option) => !handPickedProductIds.has(option.value));
	return selectable.length > 0 && selectable.every((option) => option.checked);
}

/** Coche ou décoche un produit. « Cocher toutes les SCPI » ne touche pas aux produits attribués cabinet par cabinet. */
export function toggleOfficeProduct<T extends Option>(options: T[], handPickedProductIds: Set<string>, value: string, checked: boolean): T[] {
	if (value === ALL_OFFICE_PRODUCTS) return options.map((option) => (handPickedProductIds.has(option.value) ? option : { ...option, checked }));
	return options.map((option) => (option.value === value ? { ...option, checked } : option));
}
